import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';
import { DialogMemberViewModel } from '@common/model/dialog/dialogMemberViewModel';

export const isMessageAuthor = (message: DialogMessageViewModel, member: DialogMemberViewModel | undefined): boolean => {
  return Boolean(member && member.id === message.author.id);
};
